import React from 'react';
import { isSunday, todayISO } from './attendanceApi';

const CYCLE = ['present', 'absent', 'leave', 'late'];
const STYLE = {
  present: { bg: '#dcfce7', fg: '#166534', t: 'P' },
  absent: { bg: '#fee2e2', fg: '#b91c1c', t: 'A' },
  leave: { bg: '#fef9c3', fg: '#a16207', t: 'L' },
  late: { bg: '#e0f2fe', fg: '#0369a1', t: 'T' }
};

// Draft shape: draft[studentId][date] = status. Unmarked working days DEFAULT to "present".
export const statusOf = (draft, sid, date) => (draft[sid] && draft[sid][date]) || 'present';

export default function AttendanceGrid({ students, dates, holidays, draft, onChange }) {
  const today = todayISO();
  const single = dates.length === 1;

  const cycle = (sid, date) => {
    const next = CYCLE[(CYCLE.indexOf(statusOf(draft, sid, date)) + 1) % CYCLE.length];
    onChange(sid, date, next);
  };
  const isOff = (d) => isSunday(d) || !!holidays[d] || d > today;

  if (!students.length) return <p className="am-empty">No students in this class.</p>;

  return (
    <div className="am-tablewrap">
      <table className="am-table">
        <thead>
          <tr>
            <th className="am-name">Student</th>
            {dates.map((d) => (
              <th key={d} title={holidays[d] || ''} className={holidays[d] ? 'am-hol' : isSunday(d) ? 'am-sun' : ''}>
                {single ? d : d.slice(8)}
                {holidays[d] && <div>🏖</div>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {students.map((s) => (
            <tr key={s._id}>
              <td className="am-name" title={s.name}>
                {s.rollNumber ? `${s.rollNumber}. ` : ''}{s.name}
              </td>
              {dates.map((d) => {
                if (isOff(d)) {
                  return <td key={d} className="am-cell off">{holidays[d] ? 'H' : '–'}</td>;
                }
                if (s.admissionDate && d < s.admissionDate) {
                  return <td key={d} className="am-cell off" title={`Not admitted (admission ${s.admissionDate})`}>N/A</td>;
                }
                const st = statusOf(draft, s._id, d);
                const c = STYLE[st];
                return (
                  <td key={d} className="am-cell">
                    <button onClick={() => cycle(s._id, d)} aria-label={`${s.name} ${d} ${st}`}
                      className={`am-mark ${single ? 'wide' : ''}`} style={{ backgroundColor: c.bg, color: c.fg }}>
                      {single ? `${c.t} · ${st}` : c.t}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
